export default __webpack_public_path__ + "static/media/no-results-icon.f9e89543.svg";